module.exports = __webpack_public_path__ + "img/mobile.0a83f385.png";